/**
 * 其他api
 * create by xxh
 * 2018年09月06日
 */
import request from '@/utils/request'
import { getToken } from '@/utils/auth'
import axios from 'axios'

var qs = require('qs') // 序列化参数

/**
 *首次 微信授权获取token
 * @param {*} postData 参数对象
 */
export function uploadFile (postData) {
  postData = postData || {}
  const token = getToken()
  //   postData.token = token
  postData.append('token', token)
  console.log(postData)
  let config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }
  // return axios.post('https://weixin.sealook.cn/shop/?s=/Api/System/uploadFile', postData, config)
  return axios.post('https://m.lifa-air.cn/?s=/Api/System/uploadFile', postData, config)
}

/**
 *上传微信图片
 * @param {*} postData 参数对象
 */
export function uploadWechatFile (postData) {
  postData = postData || {}
  const token = getToken()
  postData.token = token
  return request({
    url: '/Api/System/uploadWechatFile',
    method: 'post',
    data: qs.stringify(postData)
  })
}

/**
 * 更新分享商家
 * @param {*} postData 参数对象
 */
export function updateLinkID (postData) {
  postData = postData || {}
  const token = getToken()
  postData.token = token
  return request({
    url: '/Api/User/updateLinkID',
    method: 'post',
    data: qs.stringify(postData)
  })
}

/**
 * 访问统计
 * @param {*} postData 参数对象
 */
export function pageView(postData) {
  postData = postData || {}
  const token = getToken()
  postData.token = token
  return request({
    url: '/Api/Statistics/page_view',
    method: 'post',
    data: qs.stringify(postData)
  })
}



// WEBPACK FOOTER //
// ./src/api/other.js